module.exports = __webpack_public_path__ + "img/platform-activities-30-days-in-row.f16beb85.png";